// extracted by mini-css-extract-plugin
export var active = "product-tabs-module--active--zMA2s";
export var btntab = "product-tabs-module--btntab--qnMzr";
export var inactive = "product-tabs-module--inactive--122CV";
export var tabcolumnone = "product-tabs-module--tabcolumnone--aFKfB";
export var tabcolumntwo = "product-tabs-module--tabcolumntwo--sgu8x";
export var tabcontent = "product-tabs-module--tabcontent--8CCLU";
export var tabmain = "product-tabs-module--tabmain--qwit-";